// extracted by mini-css-extract-plugin
module.exports = {"container":"b2b-category_container__Z89Fm","item":"b2b-category_item__Fa8A_","light":"b2b-category_light__q6TQ2"};